class UserQueryKeys {
  constructor(private prefix: string) {}

  getCurrentUser() {
    return [this.prefix, 'current'];
  }
}

export default UserQueryKeys;
